import { ApiServiceV1 } from '@services/api.service';

export default {
  async getTokens({
    user = null, service = null, type = null, pageNum = 1, pageSize = 10,
  }) {
    const { data: { items } } = await ApiServiceV1.get('token-history', {
      params: {
        user, service, type, pageNum, pageSize,
      },
    });

    return items || [];
  },
};
